import { useSelector } from 'react-redux';
import {
  emailFormSelector,
  filterMenuSelector,
  menuMobileSelector,
  menuSelector,
  modelErrorSelector,
  modelFormSelector,
  openModalSortSelector,
  panoramaModelSelector,
} from '../../entities/ComponentsSlice';

export default function useModalService() {
  const modelError = useSelector(modelErrorSelector);
  const modelForm = useSelector(modelFormSelector);
  const menu = useSelector(menuSelector);
  const menuMobile = useSelector(menuMobileSelector);
  const emailForm = useSelector(emailFormSelector);
  const filterMenu = useSelector(filterMenuSelector);
  const panoramaModel = useSelector(panoramaModelSelector);
  const sortModal = useSelector(openModalSortSelector);

  return {
    modelError,
    modelForm,
    menu,
    menuMobile,
    emailForm,
    filterMenu,
    panoramaModel,
    sortModal,
  };
}
